module.exports = __webpack_public_path__ + "img/paper.55b62511.png";